module.exports = __webpack_public_path__ + "img/carousel1.0e8d8928.png";